<div fxLayout="column">
    <mat-card [style.background-color]="uiData.atp.color">
        <mat-card-title>
            {{data.isPendingProcessing ? 'Process Pending Students' : 'Upload Roster'}}
        </mat-card-title>
    </mat-card>
    <div>
        <mat-card *ngIf="!data.isPendingProcessing">
            <mat-card-header>
            <mat-card-title>Upload Student Roster File</mat-card-title>
            </mat-card-header>
            <mat-card-content>
            <input type="file" (change)="onFileChange($event)" (click)="resetFileInput($event)" #fileInput>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="data.isPendingProcessing">
            <mat-card-header>
            <mat-card-title>Processing Pending Students</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>{{toUploadCount}} pending student(s) loaded and ready for processing.</p>
                <p>Use "Open Matching" to match students with existing records, then click "Upload" to process.</p>
            </mat-card-content>
        </mat-card>
        &nbsp;&nbsp;
        <mat-card *ngIf="didUpload || fileProcessed">
            <mat-card-content>
                <div fxLayout="column" fxFlex="100">                                     
                    <span *ngIf="fileProcessed  && !failedToProcess"><strong>Students To Upload: {{toUploadCount}}</strong></span>                           
                    <span *ngIf="didUpload"><strong>Successfully Uploaded: {{successfullyUploadedCount}} </strong></span>                           
                    <span *ngIf="failedToUploadCount > 0"><strong>Failed to Upload: {{failedToUploadCount}}</strong></span>                           
                </div>                
            </mat-card-content>
        </mat-card>
    </div>
  <mat-card [style.background-color]="uiData.atp.color" fxLayout="row wrap" fxLayoutGap="8px">
    <button mat-raised-button color="primary" aria-label="Save" (click)="uploadPrompt()" disabled="{{failedToProcess || didUpload}}">
        {{'Upload'}}
    </button>
    <button mat-raised-button mat-dialog-close="Exit" aria-label="Exit">Exit</button>
    <button disabled="{{failedToProcess || didUpload}}" mat-raised-button aria-label="Open Matching" (click)="showStudentMatches()">Open Matching</button>
</mat-card>
</div>